<res-base-modal [modalTitle]="modalTitle" [modalAutomationId]="modalAutomationId" (closeButtonActionEmt)="closeModal()"
    [secondaryButtonLabel]="secondaryButtonLabel" [modalHelpIndex]="modalHelpIndex" [modalClass]="modalClass"
    [isBusy]="isBusy" [isBusyMessage]="isBusyMessage" [resizeHorizontal]="true" [resizeVertical]="true"
    [maximizable]="true" [isPrimaryButtonHidden]="true">
    <div *ngIf="modalData.detailType === 'ZERO_DAY_DETAILS'">
        <div class="date-range-picker">
            <span class="range-indicator">Date Range:</span>
            <res-custom-date-time-picker class="date-time-picker" name="dateStart" ngDefaultControl
                [inputPlaceholder]="defaultDatePlaceholders[0]" (focusout)="compareDateRange()" [(ngModel)]="startDate"
                (ngModelChange)="compareDateRange()" [isDateRange]="true" [hasErrorMessage]="dateError" [isStart]="true"
                [isEnd]="false" (click)="compareDateRange()" [automationId]="'zero-day-details-date-range-from-option'"
                data-automation-id="zero-day-details-date-range-from-option">
            </res-custom-date-time-picker>
            <div class="picker-separator">~~</div>
            <res-custom-date-time-picker class="date-time-picker" name="dateEnd" ngDefaultControl
                [inputPlaceholder]="defaultDatePlaceholders[1]" (focusout)="compareDateRange()" [(ngModel)]="endDate"
                (ngModelChange)="compareDateRange()" [isDateRange]="true" [hasErrorMessage]="dateError"
                [isStart]="false" [isEnd]="true" (click)="compareDateRange()"
                [automationId]="'zero-day-details-date-range-to-option'"
                data-automation-id="zero-day-details-date-range-to-option">
            </res-custom-date-time-picker>
            <div class="apply-button">
                <button type="button" data-automation-id="zero-day-details-apply-button" class="primary-button"
                    (click)="getReportDetailsForPeriod()" [disabled]='dateError || !startDate || !endDate'><i
                        class="fa fa-check"></i>Apply</button>
            </div>
        </div>
        <div class="hide-next-previous-section">
            <res-custom-checkbox class="enable-reports" content="Hide Weekends" [(ngModel)]="hideWeekends"
                [automationId]="'zero-day-details-hide-weekends'" (ngModelChange)="getReportDetailsForPeriod()"
                [disabled]='dateError || !startDate || !endDate'>
            </res-custom-checkbox>
            <button type="button" data-automation-id="zero-day-details-previous-period-button"
                class="secondary-button margin-left-previous-button" (click)="getReportDetailsForPeriod('previous')"
                [disabled]='dateError || !startDate || !endDate'>
                <i class="fa fa-chevron-circle-left color-grey-10"></i>Previous Period
            </button>
            <button type="button" data-automation-id="zero-day-details-next-period-button"
                class="secondary-button margin-left-next-button" (click)="getReportDetailsForPeriod('next')"
                [disabled]='dateError || !startDate || !endDate'>
                Next Period<i class="fa fa-chevron-circle-right color-grey-10 margin-left-next-icon"></i>
            </button>
        </div>
    </div>

    <div *ngIf="modalData.detailType === 'EXCEPTION_DETAILS'" class="nav-tabs-bar">
        <ul class="nav nav-tabs" *ngIf="tabsBarVisible()">
            <li [ngClass]="{'active': menuBarType === 'FILETYPE' }"
                [attr.data-automation-id]="modalData.reportDetails.automationId + '-file-type'"
                (click)="setBarType('FILETYPE')">
                <a>File Type</a>
            </li>
            <li [ngClass]="{'active': menuBarType === 'DOCEXT'}"
                [attr.data-automation-id]="modalData.reportDetails.automationId + '-file-extension'"
                (click)="setBarType('DOCEXT')">
                <a>File Extension</a>
            </li>
            <li [ngClass]="{'active': menuBarType === 'DOCEXT_CONFLICT' }"
                [attr.data-automation-id]="modalData.reportDetails.automationId + '-exception-extension'"
                (click)="setBarType('DOCEXT_CONFLICT')" [hidden]="hideExceptionExtensionTab()">
                <a>Extension Exceptions</a>
            </li>
        </ul>
    </div>

    <div
        *ngIf="(modalData.detailType === 'EXCEPTION_DETAILS' || modalData.detailType === 'STANDARD_DETAILS') && modalData.reportDetails.report.reportType !== 'BILLING_REPORT'">
        <button type="button"
            [attr.data-automation-id]="modalData.reportDetails.automationId + '-document-dropdown-button'"
            class="primary-button document-list-dropdown-button"
            [disabled]="!genericGrid || genericGrid.selectedRows.length == 0" (click)="onDocumentHeaderButton($event)">
            <i class="fa fa-file-text-o"></i>
            <span>Document</span>
            <i class="fa fa-caret-down"></i>
        </button>
        <span class="modalData.reportDetails.automationId + '-selected-items'">Selected:
            <span>{{selectedItems()}}</span></span>
    </div>

    <res-generic-grid #genericGrid gridName="Report Details" [columnDefs]="columnDefs"
        [automationId]="modalData.reportDetails && modalData.reportDetails.automationId ? modalData.reportDetails.automationId : modalData.detailType === 'SCAN_HISTORY' ? 'scan-history' : modalData.detailType === 'EXCEPTION_DETAILS_IMPORT' ? 'exception-details' : '' "
        [rowSelection]="rowSelection" [responseArrayCallback]="responseArrayCallback" [gridContext]="gridContext"
        [responseCallback]="responseCallback" [requestInfo]="requestInfo"
        [gridPagerCustomCallback]="gridPagerCustomCallback"
        [pagerTemplate]="((modalData.reportDetails && modalData.reportDetails.isDownloadButtonPresent) || modalData.detailType === 'EXCEPTION_DETAILS_IMPORT') && hasDownloadPermission ? pagerTemplate : null"
        [pagerVisible]="modalData.detailType !== 'SCAN_HISTORY' ? true : false"
        [cellClickedCallback]="cellClickedCallback">
    </res-generic-grid>
    <div class="no-data" *ngIf="hasNoData"><span>No Data to Display</span></div>
    <ng-template #pagerTemplate>
        <button class="download-button" (click)="downloadReport()"
            [attr.data-automation-id]="automationId + '-download-report-button'"
            [attr.title]="modalData.detailType === 'EXCEPTION_DETAILS_IMPORT' ? 'Download Filtered Grid (.csv)' : 'Download Report (.csv)'">
            <i class="fa fa-download"></i>
        </button>
    </ng-template>
    <a download #downloadLink hidden target="_blank"></a>
</res-base-modal>

<res-context-menu #documentHeaderContextMenu>
</res-context-menu>